import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import { withRouter } from "react-router";
import CustomSelect from "../../../../helpers/ui/CustomSelect"

import apiResponse from '../../../../services/apiResponse'

import UpdateBloc from '../Update/Blocs/UpdateBloc'
import moment from 'moment'

class IndexView extends Component {

    updateBloc = new UpdateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            employeeOptions: [],
            selectedEmployee: null,
            polaKerjaOptions: [],
            selectedPolaKerja: null,
            isLoadingOptEmployee: true
        }
    }

    dateParseInput = (input) =>{
        let res = "-";
        if (input != "" && input != null){
          res = moment(input).format('YYYY-MM-DD')
        }
        return res;
    }

    reformatOptionsEmployee = (raw, label, value) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = data['employee_nip'] +' - '+ data[label];
          newObj["label"] = data['employee_nip'] +' - '+ data[label];
          newObj["value"] = data[value];
          newObj["model"] = data;
      
          return newObj;
        });
    };

    reformatOptions = (raw, label, value) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = data[label];
          newObj["value"] = data[value];
          newObj["model"] = data;
      
          return newObj;
        });
    };

    submitData = async () => {
        await this.updateBloc.fetchUpdate(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                uuid: this.state.dataForm.mapping_working_hours_uuid,
                ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log(response)
                        this.setState({
                            dataForm: response,
                            selectedEmployee: response.employee
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.updateBloc.employeeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            employeeOptions: this.reformatOptionsEmployee(
                                response.result,
                                'employee_full_name',
                                'employee_uuid',
                            ),
                            isLoadingOptEmployee: false
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.updateBloc.polaKerjaChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            polaKerjaOptions: this.reformatOptions(
                                response.result,
                                'working_pattern_name',
                                'working_pattern_uuid',
                            ),
                            isLoadingOptPolaKerja: false
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.updateBloc.fetchEmployee()
        this.updateBloc.fetchPolaKerja()

        const queryParams = new URLSearchParams(this.props.location.search)
        this.updateBloc.fetchDetail({uuid: queryParams.get('uuid') })
    }

    componentWillUnmount() {
        this.updateBloc.updateChannel?.unsubscribe()
        this.updateBloc.detailChannel?.unsubscribe()
        this.updateBloc.employeeChannel?.unsubscribe()
        this.updateBloc.polaKerjaChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <CardTitle>Detail Mapping Pola Kerja Pegawai</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        {/* Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi. */}
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="presensi_exclude_absen_employee_uuid"
                                                className="col-md-3 col-form-label"
                                            >
                                            Pegawai <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <CustomSelect 
                                                    name={`presensi_exclude_absen_employee_uuid`}
                                                    errorMessage="Pilih Pegawai"
                                                    options={this.state.employeeOptions} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Pegawai"
                                                    isLoading={this.state.isLoadingOptEmployee}
                                                    onChange={
                                                        (v) => this.setState({
                                                            selectedEmployee: v.model
                                                        })
                                                    }
                                                    isDisabled={true}
                                                    defaultValue={this.state.dataForm?.mapping_working_hours_employee_uuid}
                                                    style={{'border':'1px solid #fff;'}}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            NIP 
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    placeholder=""
                                                    name="mapping_working_hours_employee_nip"
                                                    id="mapping_working_hours_employee_nip"
                                                    readonly="readonly"
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.selectedEmployee?.employee_nip}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama 
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    placeholder=""
                                                    name="presensi_exclude_absen_employee_nama"
                                                    id="presensi_exclude_absen_employee_nama"
                                                    readonly="readonly"
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.selectedEmployee?.employee_full_name}
                                                    style={{border:'1px solid #fff'}}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Pangkat/Golongan
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    placeholder=""
                                                    name="employee_current_rank_group_room"
                                                    id="employee_current_rank_group_room"
                                                    readonly="readonly"
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.selectedEmployee?.employee_current_rank_group_room}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jabatan 
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    placeholder=""
                                                    name="employee_current_position_name"
                                                    id="employee_current_position_name"
                                                    readonly="readonly"
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.selectedEmployee?.employee_current_position_name}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Unit Kerja 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="employee_current_work_unit_name"
                                                    id="employee_current_work_unit_name"
                                                    readonly="readonly"
                                                    type="textarea"
                                                    className="form-control"
                                                    value={this.state.selectedEmployee?.employee_current_work_unit_name}
                                                />
                                            </Col>
                                        </Row>

                                        <hr />

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="mapping_working_hours_working_hours_uuid"
                                                className="col-md-3 col-form-label"
                                            >
                                            Pola Kerja <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <CustomSelect 
                                                    name={`mapping_working_hours_working_hours_uuid`}
                                                    errorMessage="Pilih Pola Kerja"
                                                    options={this.state.polaKerjaOptions} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Pola Kerja"
                                                    isLoading={this.state.isLoadingOptPolaKerja}
                                                    onChange={
                                                        (v) => this.setState({
                                                            selectedPolaKerja: v.model
                                                        })
                                                    }
                                                    isDisabled={true}
                                                    defaultValue={this.state.dataForm.mapping_working_hours_working_hours_uuid}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Pola Kerja Nama
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    placeholder=""
                                                    name="mapping_working_hours_working_hours_name"
                                                    id="mapping_working_hours_working_hours_name"
                                                    readonly="readonly"
                                                    type="text"
                                                    className="form-control"
                                                    value={(this.state.selectedPolaKerja?.working_pattern_name!=null)?this.state.selectedPolaKerja?.working_pattern_name:this.state.dataForm?.mapping_working_hours_working_hours_name}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-3 col-form-label"
                                            >
                                                Tanggal Mulai <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="3">
                                                <AvField
                                                    name="mapping_working_hours_start_date"
                                                    placeholder="Tanggal Mulai"
                                                    errorMessage="Masukkan Tanggal Mulai"
                                                    type="date"
                                                    className="form-control"
                                                    onChange={e => { 
                                                        this.setState({ startDate: e.target.value });
                                                        // this.handleTanggalCuti(e.target.value)
                                                    }}
                                                    readonly="readonly"
                                                    value={this.dateParseInput(this.state.dataForm?.mapping_working_hours_start_date)}
                                                    validate={{ required: { value: true } }}
                                                    />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-3 col-form-label"
                                                >
                                                Tanggal Selesai <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="3">
                                                <AvField
                                                    name="mapping_working_hours_end_date"
                                                    placeholder="Tanggal Selesai"
                                                    errorMessage="Masukkan Tanggal Selesai"
                                                    type="date"
                                                    className="form-control"
                                                    onChange={e => { 
                                                        this.setState({ endDate: e.target.value })
                                                    }}
                                                    readonly="readonly"
                                                    value={this.dateParseInput(this.state.dataForm?.mapping_working_hours_end_date)}
                                                    validate={{ required: { value: true } }}
                                                    // min={this.state.minDateSelesai}
                                                />
                                            </Col>
                                        </Row>

                                        {/* <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <div className="form-check form-switch mb-3">
                                                    <AvCheckboxGroup name="checkboxExample" errorMessage="Agreement harus di centang">
                                                        <AvCheckbox label="Centang untuk mengaktifkan jam kerja ini dan menonaktifkan jam kerja yang sedang aktif" value="1" />
                                                    </AvCheckboxGroup>
                                                </div>
                                            </Col>
                                        </Row> */}

                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="?">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                {/* <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button> */}
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/master/pola_kerja_pegawai.html?'/>
                : null }
            </Fragment>
        )
    }

}

//export default IndexView
export default withRouter(IndexView);